module.exports = __webpack_public_path__ + "media/images/categoryIcons/healthcare_icon-6cc1a34c8bdb556b8b74cce141c5be73.svg";